import React from "react";
import { motion } from "framer-motion";
import { routingAnimation } from "../../utils/animations";

export const MainContent = ({ children }) => (
  <motion.main
    className="main_page"
    variants={routingAnimation}
    initial={routingAnimation.hidden}
    animate={routingAnimation.visible}
    transition={routingAnimation.transition}
    // `marginBottom: 100` was set inline, which no stylesheet could reach. On a
    // phone it adds 100px of scrollable height below content that already fits,
    // so a short page scrolls for no reason -- and the only thing that scroll
    // achieves is sliding the card header up under the fixed top bar. The
    // bottom spacing now comes from main_page's padding, which is already 48px
    // on desktop and 32px below 768px.
  >
    <div className="content inner_dashboard_container">
      <div className="page-content">{children}</div>
    </div>
  </motion.main>
);

export default MainContent;
